import type { ComponentProps } from 'react';
import { cn } from '../../lib/cn';
import { Button } from './Button';

export function TableActionButton({ className, size = 'sm', ...props }: ComponentProps<typeof Button>) {
  return (
    <Button
      className={cn('bg-muted text-xs text-foreground hover:bg-muted/80', className)}
      size={size}
      variant="ghost"
      {...props}
    />
  );
}
